import React, { useEffect } from "react";
import Loadable from "react-loadable";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import es from "antd/locale/es_ES";
import { ConfigProvider, notification } from "antd";
import { Icons, Loader, ThemeLoader } from "./components/base";

import { updateMessage } from "./services/store/actions/theme";
import { antdTheme } from "./utils/themes";

const loading = () => (
    <>
        <Loader />
    </>
);

const AccountLayout = Loadable({
    loader: () => import("./layouts/AccountLayout/AccountLayout"),
    loading,
});

const MainLayout = Loadable({
    loader: () => import("./layouts/MainLayout/MainLayout"),
    loading,
});

const LandingLayout = Loadable({
    loader: () => import("./layouts/LandingLayout/LandingLayout"),
    loading,
});

const App = () => {
    const dispatch = useDispatch();

    const { message } = useSelector((state) => state.theme);

    useEffect(() => {
        if (message.content !== null) {
            notification[message.type]({
                message: message.type.toUpperCase(),
                description: message.content,
                onClose: () => dispatch(updateMessage(null, null)),
            });
        }
    }, [message.content]); // eslint-disable-line

    return (
        <React.Fragment>
            <ThemeLoader />
            <Icons />

            <ConfigProvider theme={antdTheme} locale={es}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/account/*" element={<AccountLayout />} />
                        <Route path="/landing/*" element={<LandingLayout />} />
                        <Route path="/campaigns/*" element={<LandingLayout />} />
                        <Route path="/*" element={<MainLayout />} />
                    </Routes>
                </BrowserRouter>
            </ConfigProvider>
        </React.Fragment>
    );
};

export default App;
